module.exports = __webpack_public_path__ + "static/media/social-linkedin.9071c535.svg";